module.exports = new __parcel__URL__("earth.d0d356eb.png").toString();